import { render, staticRenderFns } from "./IconFolderSolid.vue?vue&type=template&id=5410c096"
import script from "./IconFolderSolid.vue?vue&type=script&lang=js"
export * from "./IconFolderSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports